import "./main.css";
import {baseStyleProps as $9LQqs$baseStyleProps, passthroughStyle as $9LQqs$passthroughStyle, dimensionValue as $9LQqs$dimensionValue, useStyleProps as $9LQqs$useStyleProps, useDOMRef as $9LQqs$useDOMRef, useBreakpoint as $9LQqs$useBreakpoint, responsiveDimensionValue as $9LQqs$responsiveDimensionValue, classNames as $9LQqs$classNames} from "@react-spectrum/utils";
import {filterDOMProps as $9LQqs$filterDOMProps} from "@react-aria/utils";
import $9LQqs$react, {forwardRef as $9LQqs$forwardRef} from "react";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $994c48bfb00b620b$var$gridStyleProps = {
    ...(0, $9LQqs$baseStyleProps),
    autoFlow: [
        "gridAutoFlow",
        (0, $9LQqs$passthroughStyle)
    ],
    autoColumns: [
        "gridAutoColumns",
        $994c48bfb00b620b$var$gridDimensionValue
    ],
    autoRows: [
        "gridAutoRows",
        $994c48bfb00b620b$var$gridDimensionValue
    ],
    areas: [
        "gridTemplateAreas",
        $994c48bfb00b620b$var$gridTemplateAreasValue
    ],
    columns: [
        "gridTemplateColumns",
        $994c48bfb00b620b$var$gridTemplateValue
    ],
    rows: [
        "gridTemplateRows",
        $994c48bfb00b620b$var$gridTemplateValue
    ],
    gap: [
        "gap",
        (0, $9LQqs$dimensionValue)
    ],
    rowGap: [
        "rowGap",
        (0, $9LQqs$dimensionValue)
    ],
    columnGap: [
        "columnGap",
        (0, $9LQqs$dimensionValue)
    ],
    justifyItems: [
        "justifyItems",
        (0, $9LQqs$passthroughStyle)
    ],
    justifyContent: [
        "justifyContent",
        (0, $9LQqs$passthroughStyle)
    ],
    alignItems: [
        "alignItems",
        (0, $9LQqs$passthroughStyle)
    ],
    alignContent: [
        "alignContent",
        (0, $9LQqs$passthroughStyle)
    ]
};
function $994c48bfb00b620b$var$Grid(props, ref) {
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $9LQqs$useStyleProps)(otherProps, $994c48bfb00b620b$var$gridStyleProps);
    styleProps.style.display = "grid"; // inline-grid?
    let domRef = (0, $9LQqs$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $9LQqs$react).createElement("div", {
        ...(0, $9LQqs$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
function $994c48bfb00b620b$export$76d90c956114f2c2(count, repeat) {
    return `repeat(${count}, ${$994c48bfb00b620b$var$gridTemplateValue(repeat)})`;
}
function $994c48bfb00b620b$export$9c1b655deaca4988(min, max) {
    return `minmax(${$994c48bfb00b620b$var$gridDimensionValue(min)}, ${$994c48bfb00b620b$var$gridDimensionValue(max)})`;
}
function $994c48bfb00b620b$export$2f0b47b0911ce698(dimension) {
    return `fit-content(${$994c48bfb00b620b$var$gridDimensionValue(dimension)})`;
}
function $994c48bfb00b620b$var$gridTemplateAreasValue(value) {
    return value.map((v)=>`"${v}"`).join("\n");
}
function $994c48bfb00b620b$var$gridDimensionValue(value) {
    if (/^max-content|min-content|minmax|auto|fit-content|repeat|subgrid/.test(value)) return value;
    return (0, $9LQqs$dimensionValue)(value);
}
function $994c48bfb00b620b$var$gridTemplateValue(value) {
    if (Array.isArray(value)) return value.map($994c48bfb00b620b$var$gridDimensionValue).join(" ");
    return $994c48bfb00b620b$var$gridDimensionValue(value);
}
/**
 * A layout container using CSS grid. Supports Spectrum dimensions as values to
 * ensure consistent and adaptive sizing and spacing.
 */ const $994c48bfb00b620b$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $9LQqs$forwardRef)($994c48bfb00b620b$var$Grid);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $01dd1839b5376a46$exports = {};

$parcel$export($01dd1839b5376a46$exports, "flex", () => $01dd1839b5376a46$export$97691fbb80847c19, (v) => $01dd1839b5376a46$export$97691fbb80847c19 = v);
$parcel$export($01dd1839b5376a46$exports, "flex-container", () => $01dd1839b5376a46$export$69d7a39fa31a000b, (v) => $01dd1839b5376a46$export$69d7a39fa31a000b = v);
$parcel$export($01dd1839b5376a46$exports, "flex-gap", () => $01dd1839b5376a46$export$31a9da8b58047a44, (v) => $01dd1839b5376a46$export$31a9da8b58047a44 = v);
var $01dd1839b5376a46$export$97691fbb80847c19;
var $01dd1839b5376a46$export$69d7a39fa31a000b;
var $01dd1839b5376a46$export$31a9da8b58047a44;
$01dd1839b5376a46$export$97691fbb80847c19 = `NW91UW_flex`;
$01dd1839b5376a46$export$69d7a39fa31a000b = `NW91UW_flex-container`;
$01dd1839b5376a46$export$31a9da8b58047a44 = `NW91UW_flex-gap`;


const $884c64d19340d345$var$flexStyleProps = {
    direction: [
        "flexDirection",
        (0, $9LQqs$passthroughStyle)
    ],
    wrap: [
        "flexWrap",
        $884c64d19340d345$var$flexWrapValue
    ],
    justifyContent: [
        "justifyContent",
        $884c64d19340d345$var$flexAlignValue
    ],
    alignItems: [
        "alignItems",
        $884c64d19340d345$var$flexAlignValue
    ],
    alignContent: [
        "alignContent",
        $884c64d19340d345$var$flexAlignValue
    ]
};
function $884c64d19340d345$var$Flex(props, ref) {
    let { children: children, ...otherProps } = props;
    let breakpointProvider = (0, $9LQqs$useBreakpoint)();
    let matchedBreakpoints = (breakpointProvider === null || breakpointProvider === void 0 ? void 0 : breakpointProvider.matchedBreakpoints) || [
        "base"
    ];
    let { styleProps: styleProps } = (0, $9LQqs$useStyleProps)(otherProps);
    let { styleProps: flexStyle } = (0, $9LQqs$useStyleProps)(otherProps, $884c64d19340d345$var$flexStyleProps);
    let domRef = (0, $9LQqs$useDOMRef)(ref);
    let style = {
        ...styleProps.style,
        ...flexStyle.style
    };
    if (props.gap != null) style.gap = (0, $9LQqs$responsiveDimensionValue)(props.gap, matchedBreakpoints);
    if (props.columnGap != null) style.columnGap = (0, $9LQqs$responsiveDimensionValue)(props.columnGap, matchedBreakpoints);
    if (props.rowGap != null) style.rowGap = (0, $9LQqs$responsiveDimensionValue)(props.rowGap, matchedBreakpoints);
    return /*#__PURE__*/ (0, $9LQqs$react).createElement("div", {
        ...(0, $9LQqs$filterDOMProps)(otherProps),
        className: (0, $9LQqs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($01dd1839b5376a46$exports))), "flex", styleProps.className),
        style: style,
        ref: domRef
    }, children);
}
/**
 * Normalize 'start' and 'end' alignment values to 'flex-start' and 'flex-end'
 * in flex containers for browser compatibility.
 */ function $884c64d19340d345$var$flexAlignValue(value) {
    if (value === "start") return "flex-start";
    if (value === "end") return "flex-end";
    return value;
}
/**
 * Takes a boolean and translates it to flex wrap or nowrap.
 */ function $884c64d19340d345$var$flexWrapValue(value) {
    if (typeof value === "boolean") return value ? "wrap" : "nowrap";
    return value;
}
/**
 * A layout container using flexbox. Provides Spectrum dimension values, and supports the gap
 * property to define consistent spacing between items.
 */ const $884c64d19340d345$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $9LQqs$forwardRef)($884c64d19340d345$var$Flex);




export {$994c48bfb00b620b$export$76d90c956114f2c2 as repeat, $994c48bfb00b620b$export$9c1b655deaca4988 as minmax, $994c48bfb00b620b$export$2f0b47b0911ce698 as fitContent, $994c48bfb00b620b$export$ef2184bd89960b14 as Grid, $884c64d19340d345$export$f51f4c4ede09e011 as Flex};
//# sourceMappingURL=module.js.map
